/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
// import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './InvoiceDetailDataServiceEntities.g';

// @ts-ignore
function invoiceQuery(recID?: number): DataServiceQuery {
    const key = recID ? { RecID: recID } : null;
    return new DataServiceQuery('Invoice', 'InvoiceDetailsEntity', DataServiceEntities.InvoiceDetailsEntityExtensionClass, key);
}

export function createGetInvoiceDetailsInput(
    queryResultSettings: IQueryResultSettings,
    getInvoiceDetails: DataServiceEntities.IGetInvoiceDetailsRequest
): IDataServiceRequest {
    const query = invoiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetInvoiceDetails',
        true,
        DataServiceEntities.InvoiceDetailsEntityExtensionClass,
        'true',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.IInvoiceDetailsEntity'
        },
        { getInvoiceDetails: getInvoiceDetails }
    );
}

export function getInvoiceDetailsAsync(
    context: IContext,
    getInvoiceDetails: DataServiceEntities.IGetInvoiceDetailsRequest,
    queryResultSettingsValue: IQueryResultSettings
): AsyncResult<DataServiceEntities.IInvoiceDetailsEntity[]> {
    const request = createGetInvoiceDetailsInput(queryResultSettingsValue || {}, getInvoiceDetails);
    return callActionOrExecute<DataServiceEntities.IInvoiceDetailsEntity[]>(request, context.callerContext);
}
